<template>
  <s-btn v-if="loggedInUser.isSuperUser" color="danger-white" icon="cog" :href>
    {{ $t('superAdmin') }}
  </s-btn>
</template>
<script setup lang="ts">
import SBtn from '../design-system/SBtn.vue';
import {useLoggedInUser} from '../composables/useLoggedInUser';

defineProps<{
  href: string;
}>();

const loggedInUser = useLoggedInUser();
</script>
